import { render } from "./MaterialRealizes.vue?vue&type=template&id=242eea88&scoped=true"
import script from "./MaterialRealizes.vue?vue&type=script&lang=js"
export * from "./MaterialRealizes.vue?vue&type=script&lang=js"

import "./MaterialRealizes.vue?vue&type=style&index=0&id=242eea88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242eea88"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QTr,QIcon,QTooltip,QSpinner,QTable,QTd});
